<template>
  <div class="PageSpasmTypes">
    <v-btn icon @click="goBack">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <h1 class="text-h5 mb-4">Tipos de Crises</h1>

    <v-card class="mb-6 elevation-2">
      <v-card-text>
        <v-form @submit.prevent="addType">
          <v-text-field
            v-model="newTypeName"
            label="Novo Tipo de Crise"
            placeholder="Ex: Espasmo em Extensão, Crise de Ausência"
            outlined
            dense
            hide-details
            class="mb-2"
          ></v-text-field>
          <v-btn block color="primary" :disabled="!newTypeName" @click="addType">
            Adicionar Tipo
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-list v-if="types.length > 0" elevation="1" class="rounded-lg">
      <v-subheader>Tipos Cadastrados</v-subheader>
      <template v-for="type in types">
        <v-list-item :key="type.id">
          <v-list-item-content v-if="editingId !== type.id">
            <v-list-item-title>{{ type.name }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-text-field
              v-model="editingName"
              dense
              outlined
              hide-details
              autofocus
              @keyup.enter="saveEdit(type)"
              @keyup.esc="cancelEdit"
            ></v-text-field>
          </v-list-item-content>
          <v-list-item-action class="flex-row ma-0">
            <template v-if="editingId !== type.id">
              <v-btn icon @click="startEdit(type)">
                <v-icon color="grey darken-1">mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="error" @click="confirmDelete(type)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <v-btn icon color="success" :disabled="!editingName" @click="saveEdit(type)">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn icon @click="cancelEdit">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-list-item-action>
        </v-list-item>
        <v-divider :key="'div-' + type.id"></v-divider>
      </template>
    </v-list>

    <v-alert v-else type="info" text class="mt-4">
      Nenhum tipo de crise cadastrado ainda.
    </v-alert>

    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import SpasmService from '../../lib/spasms-control/SpasmService'
import { getDependent, getToken } from '../../utils'

export default {
  name: 'PageSpasmTypes',
  data() {
    return {
      dependentId: null,
      types: [],
      newTypeName: '',
      editingId: null,
      editingName: '',
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success'
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    loadTypes() {
      const authToken = getToken()
      const service = new SpasmService(authToken)
      service.getSpasmTypes(this.dependentId).then(response => {
        this.types = response.data
      })
    },
    addType() {
      if (!this.newTypeName) return

      const authToken = getToken()
      const service = new SpasmService(authToken)
      service.createSpasmType({
        dependent: this.dependentId,
        name: this.newTypeName
      }).then(() => {
        this.newTypeName = ''
        this.showSnackbar('Tipo de crise adicionado com sucesso!')
        this.loadTypes()
      }).catch(err => {
        this.showSnackbar('Erro ao adicionar tipo: ' + err.message, 'error')
      })
    },
    startEdit(type) {
      this.editingId = type.id
      this.editingName = type.name
    },
    cancelEdit() {
      this.editingId = null
      this.editingName = ''
    },
    saveEdit(type) {
      if (!this.editingName || this.editingName === type.name) {
        this.cancelEdit()
        return
      }

      const authToken = getToken()
      const service = new SpasmService(authToken)
      service.updateSpasmType(type.id, { name: this.editingName }).then(() => {
        this.cancelEdit()
        this.showSnackbar('Tipo de crise atualizado!')
        this.loadTypes()
      }).catch(err => {
        this.showSnackbar('Erro ao atualizar: ' + err.message, 'error')
      })
    },
    confirmDelete(type) {
      if (confirm(`Tem certeza que deseja excluir o tipo "${type.name}"?`)) {
        const authToken = getToken()
        const service = new SpasmService(authToken)
        service.deleteSpasmType(type.id).then(() => {
          this.showSnackbar('Tipo de crise excluído!')
          this.loadTypes()
        }).catch(err => {
          this.showSnackbar('Erro ao excluir: ' + err.message, 'error')
        })
      }
    },
    showSnackbar(text, color = 'success') {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    }
  },
  mounted() {
    const dependent = getDependent()
    if (!dependent) {
      this.$router.push('/dependents')
      return
    }
    this.dependentId = dependent.id
    this.loadTypes()
  }
}
</script>
